import * as React from 'react'
import './SettlementsList.scss'
import { settlementItem } from "../../reducers/types";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell } from "../../components/CustomUIComp/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import noDataIcon from '../../images/null_icon.svg';
import { injectIntl, IntlShape } from 'react-intl'

interface IProps {
  list: settlementItem[],
  orgCurrency: string,
  currency: string,
  intl: IntlShape
}

interface IState {
  anchorEl: null | HTMLElement,
  openItem: number
}

class SettlementsList extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      anchorEl: null,
      openItem: -1
    }
  }

  handleMoreClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
    this.setState({
      anchorEl: event.currentTarget,
      openItem: index
    })
  }
  handleMoreClose = () => {
    this.setState({
      anchorEl: null,
      openItem: -1
    })
  }
  onDownload = (url: string) => {
    this.handleMoreClose()
    let a = document.createElement('a');
    a.href = url;
    a.click();
  }
  dateFormat = (date: string): string => {
    return date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3")
  }

  public render() {
    let { list, intl } = this.props
    return (
      <div className="Settlements">
        <div className="header">
          <h2>{intl.formatMessage({ id: 'settlementList' })}</h2>
        </div>
        <div className="settlementList">
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'settlementDate' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'settlementAmt' })}</StyledTableCell>
                {/* <StyledTableCell align='center'>{intl.formatMessage({ id: 'collectAmt' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'refundAmt' })}</StyledTableCell> */}
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'fee' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'currency' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'transNum' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'refundNum' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'operations' })}</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((item, i) => {
                return (<TableRow hover key={`${item.tradeDate}-${i}`}>
                  <StyledTableCell align="center">
                    <div className="infoGroup">
                      {this.dateFormat(item.tradeDate)}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className="amt red">{item.bankAmt ? item.bankAmt.toFixed(2) : ''}</span>
                  </StyledTableCell>
                  {/* <StyledTableCell align='center'>
                    <span className="amt">{item.payAmt ? item.payAmt.toFixed(2) : ''}</span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className="amt">{item.refundAmt ? item.refundAmt.toFixed(2) : ''}</span>
                  </StyledTableCell> */}
                  <StyledTableCell align='center'>
                    <span className="amt">{item.feeAmt !== null && item.feeAmt !== undefined ? item.feeAmt.toFixed(2) : ''}</span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className="amt">{item.orgCurrency}</span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className="amt">{item.payNum}</span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className="amt">{item.refundNum}</span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <IconButton
                      aria-label="more"
                      aria-controls="user-menu"
                      aria-haspopup="true"
                      onClick={(event: React.MouseEvent<HTMLElement>) => this.handleMoreClick(event, i)}
                    >
                      <MoreHorizIcon />
                    </IconButton>
                    <Menu
                      id="user-menu"
                      anchorEl={this.state.anchorEl}
                      keepMounted
                      open={this.state.openItem === i}
                      onClose={this.handleMoreClose}
                    >
                      <MenuItem onClick={() => this.onDownload(item.url)}>
                        {intl.formatMessage({ id: 'downloadDetail' })}
                      </MenuItem>
                    </Menu>
                  </StyledTableCell>
                </TableRow>)
              })}
            </TableBody>
          </Table>
          {list.length === 0 ?
            <div className="noData">
              <img src={noDataIcon} alt="no data" />
              <p>{intl.formatMessage({ id: 'noData' })}</p>
            </div>
            : null}
        </div>
      </div>
    );
  }
}

export default injectIntl(SettlementsList)